var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-container',[_c('el-header',{staticStyle:{"height":"85px"}},[_c('topHead',{attrs:{"detalis":_vm.detalis}})],1),_c('el-main',[_c('div',{staticClass:"card"},[_c('reject'),_c('fail')],1)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }